<template>
  <div class="slider-table-input-container mb-3">
    <question-display :question="question" customClass="customHeader"></question-display>

    <div v-for="(row, index) in question.rows" :key="index" class="form-group">
      <label class="form-label">{{ row.label }}</label>
      <div style="display: flex; padding: 0 4px;">
        <input type="range" min="0" max="100" v-model="rowValues[index]" @input="updateSlider(index)" />
        <div class="text-center progressBar">
          &nbsp;&nbsp;<span class="sliderValue">{{ rowValues[index] }}%</span>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <strong :class="totalClass">Total: {{ totalPercentage }}%</strong>
    </div>
    <small v-if="showValidation && totalPercentage !== 100" class="text-danger">
      Please ensure the total percentage equals 100%.
    </small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
    QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    return {
      rowValues: surveyService.getAnswer(this.question.id) || Array(this.question.rows.length).fill(0)
    };
  },
  computed: {
    totalPercentage() {
      return this.rowValues.reduce((acc, val) => acc + Number(val), 0);
    },
    totalClass() {
      return {
        'text-success': this.totalPercentage === 100,
        'text-danger': this.totalPercentage !== 100
      };
    }
  },
  methods: {
    updateSlider(index) {
      const newTotal = this.totalPercentage;
      if (newTotal > 100) {
        // Revert the last change if the total exceeds 100%
        this.rowValues[index] = Math.max(0, 100 - (newTotal - this.rowValues[index]));
      }
      surveyService.setAnswer(this.question.id, this.rowValues);
      this.$emit('input', this.rowValues);
    }
  },
  watch: {
    question(newQuestion) {
      this.rowValues = surveyService.getAnswer(newQuestion.id) || Array(newQuestion.rows.length).fill(0);
    }
  }
};
</script>

<style scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
</style>
